module.exports = __webpack_public_path__ + "img/f4.8233995a.svg";